import { render, staticRenderFns } from "./readonly.vue.js?vue&type=template&id=8a0188b2!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./readonly.vue?vue&type=template&id=8a0188b2"
import script from "./readonly.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./readonly.vue?vue&type=script&lang=js"
export * from "./readonly.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./readonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports